import React from "react";
import {Box, Grid} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";

import { lastDayOfMonth, parseISO} from "date-fns";

import OSKPI from "../OSKPI";
import EtapaKPI from "./EtapaKPI";

import {useSelector} from "react-redux";


const useStyles = makeStyles(theme => ({

    mainPaper: {
        display: 'flex',
        flexGrow: 1,
        alignItems:'stretch',

        backgroundColor: '#f5f1f1',
        padding: '10px',
        margin: '10px',
        borderRadius: '5px',


    },
    mainGrid: {
        display: 'flex',
        flexGrow: 1,
       // backgroundColor: 'red',
        flexDirection: "row",
        flexWrap: "nowrap",
    },
    areaTenant: {
      flex: 1,
      flexDirection: "row",
      flexWrap: "wrap",
       // backgroundColor: 'yellowgreen',
        textAlign: 'center',
  },
    areaKPI: {
        flex: 1,
        flexDirection: "row",
        flexWrap: "wrap",
       // backgroundColor: 'green'
    },
    areaOS: {
        flex: 1,
        flexDirection: "row",
        flexWrap: "nowrap",
       // backgroundColor: 'blue'
    },
    areaEtapas: {
        flex: 1,
        flexDirection: "row",
        flexWrap: "wrap",
       //backgroundColor: 'orange'
    },
    navLogo: {
        margin: '0px',
        // height: "90x",
        width: "160px",
        verticalAlign: 'middle'
    },
}));




const I4PlantGrid = ({ planta, mostrarEtapas, mostrarTodosKPIs } ) => {
    const classes = useStyles();

    const periodMin =  useSelector( state =>  state.filter.periodMin);
    const periodMax =  useSelector( state =>  state.filter.periodMax);

    const imglogo = `http://arq-tipler.digama.com.br/images/tnt${planta.tenantId}/logoEmpresaBco.png`;




    const hoje = new Date();
    let diaAtual = hoje.getDate();
    let ultDiaMes = lastDayOfMonth(hoje).getDate();
    let projecao = Math.round( (    ((planta.oss.recapadosQtde / diaAtual) * ultDiaMes) /  planta.oss.meta ) * 100);


    if (parseISO(periodMax).getMonth() !== hoje.getMonth() ) {
        diaAtual = parseISO(periodMax) .getDate();
        ultDiaMes = lastDayOfMonth(parseISO(periodMax)).getDate();
        projecao =  Math.round( (    (planta.oss.recapadosQtde) /  planta.oss.meta ) * 100);
    }

    console.log(planta)


    const corMeta = (projecao >= 100)? 'green' : 'red';

    return (
        <Grid container item xs={12} sm={12} md={6} lg={6} xl={6} style={{  alignItems:'stretch',  padding: '2px'}} >
            <Grid className={classes.mainPaper}>
                <Grid className={classes.mainGrid} >
                    <Grid  item className={classes.areaTenant} xs={3} lg={3} xl={3}>
                        <Grid item>
                            <Box
                                component="img"
                                sx={{
                                    // height: '30%',
                                    width: '90%',
                                    // maxHeight: { xs: 233, md: 167 },
                                    // maxWidth: { xs: 350, md: 250 },
                                }}
                                alt={planta.estabDescricao}
                                src={imglogo}
                            />


                        </Grid>
                        {/*<Typography>{planta.tenantId},</Typography>*/}
                        {/*<Typography>{planta.estabDescricao},</Typography>*/}
                        {/*<Typography>{planta.estabId},</Typography>*/}

                    </Grid>
                    <Grid  item   className={classes.areaKPI}  xs={9} lg={9} xl={9}>
                        <Grid container item  className={classes.areaOS}  xs={12} lg={12} xl={12}>
                            <OSKPI titulo="RECAPADOS"  valor={planta.oss.recapadosQtde}/>
                            <OSKPI titulo="VULCANIZADOS"  valor={planta.oss.vulcanizadosQtde}/>
                            <OSKPI titulo="CONCLUIDOS"  valor={planta.oss.concluidosQtde}/>
                            <OSKPI titulo="META"  valor={planta.oss.meta}/>
                            <OSKPI titulo="PROJ/META" cor={corMeta} valor={projecao+'%'}/>

                            { mostrarTodosKPIs && <React.Fragment>
                                <OSKPI titulo="RECEBIDOS"  valor={planta.oss.recebidosQtde}/>
                                {/*<OSKPI titulo="INICIADOS"  valor={planta.oss.iniciadosQtde}/>*/}
                                {/**/}
                                 <OSKPI titulo="REPROV."  valor={planta.oss.reprovQtde}/>
                                <OSKPI titulo="RECUSA"  valor={planta.oss.recusaQtde}/>
                                <OSKPI titulo="ENVIADOS"  valor={planta.oss.saidaQtde}/>
                            </React.Fragment> }

                        </Grid>
                        { mostrarEtapas && <Grid container item  className={classes.areaEtapas}  xs={12} lg={12} xl={12}>
                            {
                                planta.etapas.map( (e,ix) => {
                                    return (<EtapaKPI key={ix} titulo={e.etDescricao} valor={e.qtdeExecutadas} valor2={e.numOS}/>)
                                })

                            }
                        </Grid> }

                    </Grid>

                </Grid>
            </Grid>

        </Grid >
       );


}

export default I4PlantGrid;
